function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Visuals",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing",
  transform: "translate(-150.000000, -50.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Topmenu",
  transform: "translate(150.000000, 45.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy",
  transform: "translate(0.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(19.000000, 17.500000) rotate(90.000000) translate(-19.000000, -17.500000) translate(5.000000, -1.000000)",
  fill: "#54C1FC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0 L27,0 C27.5522847,-1.01453063e-16 28,0.44771525 28,1 L28,5 C28,5.55228475 27.5522847,6 27,6 L7.32687894,6 C6.77459419,6 6.32687894,6.44771525 6.32687894,7 L6.32687894,27 C6.32687894,27.5522847 5.87916369,28 5.32687894,28 L1,28 C0.44771525,28 2.02974496e-15,27.5522847 0,27 L0,1 C-1.78657678e-16,0.44771525 0.44771525,-9.5692398e-18 1,0 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,9 L27,9 C27.5522847,9 28,9.44771525 28,10 L28,14 C28,14.5522847 27.5522847,15 27,15 L7.32687894,15 C6.77459419,15 6.32687894,15.4477153 6.32687894,16 L6.32687894,36 C6.32687894,36.5522847 5.87916369,37 5.32687894,37 L1,37 C0.44771525,37 2.02974496e-15,36.5522847 0,36 L0,10 C-1.78657678e-16,9.44771525 0.44771525,9 1,9 Z",
  id: "Rectangle-Copy",
  transform: "translate(14.000000, 23.000000) scale(-1, -1) translate(-14.000000, -23.000000) "
}))))));

function SvgSekuritanceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSekuritanceLogo);
export default __webpack_public_path__ + "static/media/sekuritance-logo.e9b2e466.svg";
export { ForwardRef as ReactComponent };